// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"6c5a0327","290":"817d212f","352":"9f497df5","385":"e07c08d0","453":"5c44f6e8"}[chunkId] + ".chunk.js";
};